import axios from "axios";

import React, { useEffect, useRef, useState } from "react";
import "./InvoicePage.scss";

import { default as invoiceArrowLeft} from "../../icons/invoiceArrowLeft.svg";
import { default as invoiceArrowRight} from "../../icons/invoiceArrowRight.svg";
import { default as downloadIcon } from "../../icons/download2.svg";

import InvoiceOrderComponent from "./components/InvoiceOrderComponent";
import InvoicePriceComponent from "./components/InvoicePriceComponent";
import InvoiceCustomerComponent from "./components/InvoiceCustomerComponent";
import InvoiceSellerComponent from "./components/InvoiceSellerComponent";
import InvoiceDeliveryComponent from "./components/InvoiceDeliveryComponent";
import InvoicePdfComponent from "./components/InvoicePDFComponent";
import { useNavigate, useParams } from "react-router-dom";
import { handleDownloadPDF } from "../../components/organisms/BankPaymentDrawer/InvoiceSingle";
import { useContent, useLanguages } from "../../hooks/content";
import { Returntext } from "../Landings/common/returnText";

function InvoicePage() {
    const navigate = useNavigate();
    const { lang } = useLanguages();
    const { contentManagementData, contentIsLoading } = useContent();
    const [loading, setLoading] = useState(true);
    const [payload, setPayload] = useState(null);
    const [selectedTracking, selectTracking] = useState(0);
    const { id } = useParams();
    const pdfRef = useRef(null);

    const updateTrackingIndex = (newIndex) => {
        if (selectedTracking === newIndex) return;
        if (newIndex < 0) return;
        if (newIndex > payload.orders.length - 1) return;

        selectTracking(newIndex);
    }

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/orders/group/${id}`)
            .then((res) => {
                setPayload(res.data);
                setLoading(false)
            }).catch((err) => {
                console.error(err);
                navigate('/');
            });
    }, [])

    if (loading || !payload || contentIsLoading) return <div></div>

    return (
        <>
            <InvoicePdfComponent ref={pdfRef} props={payload} />
            <div className="invoice-container">
                <div className="left">
                    <div className="section-header">
                        <span>{ Returntext(contentManagementData, 'poi_title_order_location', lang) }</span>
                        <div className="left-action">
                        <span onClick={() => updateTrackingIndex(selectedTracking - 1)}>
                            <img src={ invoiceArrowLeft } alt="dot"/>
                        </span>
                            <span onClick={() => updateTrackingIndex(selectedTracking + 1)}>
                            <img src={ invoiceArrowRight } alt="dot"/>
                        </span>
                        </div>
                    </div>
                    <InvoiceDeliveryComponent
                        orders={payload.orders}
                        selectedTracking={selectedTracking}
                        updateTrackingIndex={updateTrackingIndex} />

                    <div className="section-header mob">
                        <span>{ Returntext(contentManagementData, 'poi_title_order_invoice', lang) }</span>
                        <span className="right-action"
                              onClick={() => handleDownloadPDF(pdfRef.current, '1', '#EBE9E4')}>
                            <img src={downloadIcon} alt="download"/>
                            <span>{ Returntext(contentManagementData, 'poi_button_download_pdf', lang)  }</span>
                        </span>
                    </div>
                    <InvoiceOrderComponent props={payload.orders} pdf={false} />
                </div>

                <div className="right">
                    <div className="section-header">
                        <span>{ Returntext(contentManagementData, 'poi_title_order_invoice', lang) }</span>
                        <span className="right-action"
                              onClick={() => handleDownloadPDF(pdfRef.current, '1', '#EBE9E4')}>
                            <img src={downloadIcon} alt="donwload"/>
                            <span>{ Returntext(contentManagementData, 'poi_button_download_pdf', lang)  }</span>
                        </span>
                    </div>
                    <InvoicePriceComponent props={payload.costs} />
                    <InvoiceCustomerComponent props={payload.issuer}/>
                    <InvoiceSellerComponent props={payload.service_providers}/>
                </div>
            </div>
        </>

    )
}

export default InvoicePage;